import { useEffect } from 'react';
import Okta from 'providers/Okta';
import Logger from 'utilities/logger';

const useCheckAuthentication = onCompleted => {
  useEffect(() => {
    const logger = Logger('Check Authentication');
    const auth = Okta();
    auth.client.tokenManager
      .get('idToken')
      .then(token => onCompleted(token))
      .catch(err => logger.error(err));
  }, []);
};

export default useCheckAuthentication;
